import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { DataTestType } from '@y42/data-test';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

interface GridGroupObject {
  value: unknown;
  toString: () => string;
  toNumber: () => number;
}

@UntilDestroy()
@Component({
  selector: 'y42-data-test-type-cell-renderer',
  templateUrl: './data-test-type-cell-renderer.component.html',
  styleUrls: ['./data-test-type-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestTypeCellRendererComponent implements ICellRendererAngularComp {
  private readonly params$$ = new BehaviorSubject<ICellRendererParams<unknown, DataTestType | GridGroupObject> | null>(
    null,
  );

  readonly state = connectState(this, {
    dataTestType: this.params$$.pipe(map((params) => (this.isDataTestType(params?.value) ? params?.value : null))),
    aggFuncValue: this.params$$.pipe(
      map((params) => (this.isGridGroupObject(params?.value) ? params?.value.toString() : null)),
    ),
  });

  agInit(params: ICellRendererParams<unknown, DataTestType | GridGroupObject>): void {
    this.params$$.next(params);
  }

  refresh(params: ICellRendererParams<unknown, DataTestType>): boolean {
    this.params$$.next(params);
    return true;
  }

  private isDataTestType(obj: unknown): obj is DataTestType {
    return typeof obj === 'string' && obj.length > 0;
  }

  private isGridGroupObject(obj: unknown): obj is GridGroupObject {
    // isNotNullish doesn't work here
    return obj !== null && obj !== undefined && typeof obj === 'object' && 'value' in obj && 'toString' in obj;
  }
}
